import React from 'react';
import toast from 'react-hot-toast';

/**
 * window.confirm 대체 - Electron에서 alert/confirm 후 input 먹통 방지
 * Promise 기반으로 동작하며 toast UI를 사용합니다.
 *
 * 사용법: const ok = await confirmDialog('삭제하시겠습니까?');
 */
export function confirmDialog(message) {
  return new Promise((resolve) => {
    toast(
      (t) => (
        React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '12px', minWidth: '260px' } },
          React.createElement('span', { style: { fontSize: '14px', lineHeight: '1.5', color: '#f9fafb', fontWeight: 500 } }, message),
          React.createElement('div', { style: { display: 'flex', justifyContent: 'flex-end', gap: '8px' } },
            React.createElement('button', {
              onClick: () => { toast.dismiss(t.id); resolve(false); },
              style: {
                padding: '6px 16px', borderRadius: '6px', border: '1px solid #4b5563',
                background: '#ffffff', color: '#111827', cursor: 'pointer', fontSize: '13px', fontWeight: 500,
              }
            }, '취소'),
            React.createElement('button', {
              onClick: () => { toast.dismiss(t.id); resolve(true); },
              style: {
                padding: '6px 16px', borderRadius: '6px', border: 'none',
                background: '#2563eb', color: '#ffffff', cursor: 'pointer', fontSize: '13px', fontWeight: 500,
              }
            }, '확인')
          )
        )
      ),
      { duration: Infinity, position: 'top-center' }
    );
  });
}
